import { Form, Input, message, Modal } from "antd";
import React, { useState } from "react";
import type { VolunteerSlot, VolunteerTask } from "../types";
import type { VolunteerStore } from "../store";

interface Props {
  store: VolunteerStore;
  task: VolunteerTask;
  slot: VolunteerSlot;
  open: boolean;
  onClose: () => void;
}

export const SignupModal = ({ store, task, slot, open, onClose }: Props) => {
  const [form] = Form.useForm();
  const [submitting, setSubmitting] = useState(false);

  const handleOk = async () => {
    const values = await form.validateFields();
    // if (!values.email && !values.phone) {
    //   message.error("Bitte E-Mail oder Telefonnummer angeben.");
    //   return;
    // }
    setSubmitting(true);
    try {
      await store.createSignup({
        slotId: slot.objectId!,
        firstName: values.firstName,
        lastName: values.lastName,
        email: values.email || undefined,
        phone: values.phone || undefined,
        note: task.notesTitle ? values.note || undefined : undefined,
      });
      message.success("Danke für deine Anmeldung!");
      form.resetFields();
      onClose();
    } catch (e: any) {
      message.error(e?.message ?? "Anmeldung fehlgeschlagen.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal
      open={open}
      title={`Eintragen: ${task.title}${slot.label ? ` – ${slot.label}` : ""}`}
      okText="Eintragen"
      cancelText="Abbrechen"
      confirmLoading={submitting}
      onOk={handleOk}
      onCancel={() => {
        form.resetFields();
        onClose();
      }}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="firstName"
          label="Vorname"
          rules={[{ required: true, message: "Bitte Vorname eingeben" }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="lastName"
          label="Nachname"
          rules={[{ required: true, message: "Bitte Nachname eingeben" }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="email"
          label="E-Mail"
          rules={[{ required: false, type: "email", message: "Bitte gültige E-Mail eingeben" }]}
        >
          <Input type="email" />
        </Form.Item>
        <Form.Item name="phone" label="Telefonnummer">
          <Input />
        </Form.Item>
        {task.notesTitle && (
          <Form.Item name="note" label={task.notesTitle}>
            <Input />
          </Form.Item>
        )}
      </Form>
      <div style={{ color: "#888", fontSize: 12 }}>
        Dein Vorname und der abgekürzte Nachname werden öffentlich in der Liste angezeigt
        {task.notesTitle ? ", zusammen mit deiner Angabe oben" : ""}. E-Mail und Telefonnummer
        bleiben privat.
      </div>
    </Modal>
  );
};
